var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossDarkgreySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7279,
    cy: 13,
    r: 8.5,
    transform: "rotate(-45 12.7279 13)",
    fill: "#4C657A",
    stroke: "#4C657A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1117 9.96954L14.0812 13L17.1117 16.0305L16.1015 17.0406L13.0711 14.0102L10.0406 17.0406L9.03046 16.0305L12.0609 13L9.03046 9.96954L10.0406 8.95939L13.0711 11.9898L16.1015 8.95939L17.1117 9.96954Z",
    fill: "#EFF3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossDarkgreySelected);
export default __webpack_public_path__ + "static/media/cross_darkgrey_selected.82ea31b06c834606c004320d1b3e91de.svg";
export { ForwardRef as ReactComponent };